/**
 * Created by admin on 2017/7/26.
 */
export const loadingTemplate = `
    <div class="ivu-spin ivu-spin-large">
        <div class="ivu-spin-main">
            <span class="ivu-spin-dot" style="display: inline-block;"></span>
        </div>
    </div>
`

export const noDataTemplate = `
    <div class="o-TAC">
        <i class="oms-icon omsi-No-data"></i>
        <div class="oms-no-data-tpl">无数据</div>
    </div>
`
